"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var node_1 = require("./node");
var line_1 = require("./line");
var status_1 = require("./status");
var TopologyData = /** @class */function () {
  function TopologyData(json) {
    this.nodes = [];
    this.lines = [];
    this.lineName = 'curve';
    this.fromArrowType = '';
    this.toArrowType = 'triangleSolid';
    this.scale = 1;
    this.locked = status_1.Lock.None;
    if (json) {
      this.nodes = [];
      for (var _i = 0, _a = json.nodes; _i < _a.length; _i++) {
        var item = _a[_i];
        this.nodes.push(new node_1.Node(item));
      }
      this.lines = [];
      for (var _b = 0, _c = json.lines; _b < _c.length; _b++) {
        var item = _c[_b];
        this.lines.push(new line_1.Line(item));
      }
      this.lineName = json.lineName || 'curve';
      this.fromArrowType = json.fromArrowType || '';
      this.toArrowType = json.toArrowType || 'triangleSolid';
      this.scale = json.scale || 1;
      this.locked = json.locked || status_1.Lock.None;
      this.bkImage = json.bkImage;
      this.bkColor = json.bkColor;
    }
  }
  return TopologyData;
}();
exports.TopologyData = TopologyData;